import { lazy } from "react";
import FullPageLayout from "../layout/FullPageLayout";
import RequireAuth from "../components/RequireAuth";
import RequireRole from "../components/RequireRole";
import Loadable from "../components/Loadable";
import { Role } from "../constants/Role";

const AdminLandingView = Loadable(lazy(() => import("../views/AdminLandingView")));
const ApiKeysView = Loadable(lazy(() => import("../views/ApiKeysView")));
const EvueConfigView = Loadable(lazy(() => import("../views/EvueConfigView")));
const TelemetryView = Loadable(lazy(() => import("../views/TelemetryView")));

export const AdminRoutes = {
  path: "/admin",
  element: (
    <RequireAuth>
      <RequireRole roles={[Role.ADMIN]}>
        <FullPageLayout />
      </RequireRole>
    </RequireAuth>
  ),
  children: [
    {
      index: true,
      element: <AdminLandingView />,
    },
    {
      path: "api-keys",
      element: <ApiKeysView />,
    },
    {
      path: "telemetry",
      element: <TelemetryView />,
    },
    {
      path: "evue-config",
      element: <EvueConfigView />,
    },
  ],
};
